import { useEffect, useState } from "react";

import { Page } from "@/ui/Layout/Page";
import { Loading } from "@/ui/Layout/Loading";
import Button from "@/ui/Button";
import { ButtonTypes } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { inboxAccess } from "./api";

// LI-5 — Launch Inbox (Specs/Launch Inbox v1 — PRD): the team inbox, signed in with the
// Launch OS login and shown inside the Launch OS frame.
export const LaunchInbox = ({ name = "Launch Inbox" }: { name?: string }) => {
  const [url, setUrl] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    const token = getSessionToken();
    if (!token) {
      setMessage("Sign in to Launch OS to open Launch Inbox.");
      return;
    }
    inboxAccess(token).then((r) => {
      if (!live) return;
      if (r.ok) setUrl(r.url);
      else setMessage(r.message);
    });
    return () => { live = false; };
  }, []);

  // A fresh link for a full browser tab (the frame's link has already been used).
  const openInTab = async () => {
    const token = getSessionToken();
    if (!token) return;
    const r = await inboxAccess(token);
    if (r.ok) window.open(r.url, "_blank", "noopener");
    else setMessage(r.message);
  };

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: url ? <Button label="Open in a new tab" type={ButtonTypes.OUTLINED} onClick={openInTab} /> : null,
      }}
    >
      {message ? (
        <div className="flex h-full items-center justify-center p-10">
          <p className="max-w-md text-center text-sm text-gray-600 dark:text-gray-300">{message}</p>
        </div>
      ) : url ? (
        <iframe
          title="Launch Inbox"
          src={url}
          className="block w-full border-0"
          style={{ height: "calc(100vh - 64px)" }}
          allow="clipboard-read; clipboard-write; microphone; camera; notifications"
        />
      ) : (
        <Loading />
      )}
    </Page>
  );
};
